import Text from "components/base/Text";
import {
  MotionBox as Box,
  MotionFlex as Flex,
  MotionGrid as Grid,
  MotionGridItem as GridItem,
} from "utils/motion";
import Trans from "components/base/Trans";

const appearBelow = (delay) => ({
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay } },
});

const Item = ({ label, value, delay, ...props }) => (
  <GridItem
    {...props}
    initial="hidden"
    variants={appearBelow(delay)}
    animate="visible"
  >
    <Flex align="center" direction="column">
      <Text
        type="title_md"
        color="white"
        textTransform="lowercase"
        letterSpacing={0}
        align="center"
      >
        {value}
      </Text>
      <Text type="title_xs" color="white" align="center">
        {label}
      </Text>
    </Flex>
  </GridItem>
);

export default function LandingGearOverText({
  title,
  subtitle,
  description,
  titleProps,
  descriptionProps,
}) {
  return (
    <>
      <Box
        position="absolute"
        top="65"
        h="100vh"
        w="100vw"
        px="md"
        minH="600px"
        {...titleProps}
      >
        <Text mt="xl" color="primary" type="title_md" textAlign="center">
          {subtitle}
        </Text>
        <Text color="white" type="headline_md" textAlign="center">
          {title}
        </Text>
      </Box>
      <Flex w="full" justifyContent="center" position="absolute" bottom="-25">
        <Flex
          maxW="md"
          w={["95vw", null, "80vw", "60vw"]}
          mb={["80px", null, null, "xxl"]}
          pb={[4, null, 0]}
          direction="column"
          {...descriptionProps}
        >
          {description ? (
            <Text color="white" type="p_lg" textAlign="center">
              {description}
            </Text>
          ) : (
            <Grid
              w="100%"
              maxW="800px"
              templateColumns={["repeat(2, 1fr)", null, "repeat(4, 1fr)"]}
              gap={4}
            >
              <Item
                value={<Trans id="LBL_TECHSPEC_VALUE_2" />}
                label={<Trans id="LBL_TECHSPEC_LABEL_2" />}
                delay={1.6}
              />
              <Item
                value={<Trans id="LBL_TECHSPEC_VALUE_1" />}
                label={<Trans id="LBL_TECHSPEC_LABEL_1" />}
                delay={1.7}
              />
              <Item
                value={<Trans id="LBL_TECHSPEC_VALUE_4" />}
                label={<Trans id="LBL_TECHSPEC_LABEL_4" />}
                delay={1.8}
              />
              <Item
                value={<Trans id="LBL_TECHSPEC_VALUE_3" />}
                label={<Trans id="LBL_TECHSPEC_LABEL_3" />}
                delay={1.9}
              />
            </Grid>
          )}
        </Flex>
      </Flex>
    </>
  );
}
